<template>
    <div class="container">
        <div class="row">
            <div class="col-xs-10">
                <basic-information :person="person"></basic-information>
                
                <mail-subscription-list :person="person"></mail-subscription-list>
            </div>

            <div class="col-xs-14">
                <div v-if="!loading">
                    <subscription
                            v-for="subscription in subscriptions.data"
                            :key="subscription.id"
                            :subscription="subscription"
                    ></subscription>
                </div>

                <timeline :person="person"></timeline>
            </div>
        </div>
    </div>
</template>

<script>
    import BasicInformation from '@/pages/People/People/Edit/Tabs/Dashboard/Panels/BasicInformation'
    import Load from '@/mixins/Load'
    import MailSubscriptionList from '@/pages/People/People/Edit/Tabs/Dashboard/Panels/MailSubscriptionList'
    import Subscription from '@/pages/People/People/Edit/Tabs/Dashboard/Panels/Subscription'
    import Timeline from '@/pages/People/People/Edit/Tabs/Dashboard/Panels/Timeline'

    export default {
        components: {BasicInformation, Load, MailSubscriptionList, Subscription, Timeline},

        mixins: [Load],

        model: {
            prop: 'person',
            event: 'person-updated'
        },

        props: ['person'],

        data() {
            return {
                subscriptions: null
            }
        },

        mounted() {
            this.load({
                subscriptions: '/api/v1/subscriptions?person=' + this.person.data.id
            })
        }
    }
</script>
